<template>
  <article class="bootcamp">
    <div class="bootcamp__mobile-pass">
      <Passes :passName="learningAreaName" :size="45" />
    </div>
    <div
      class="bootcamp__static-wrapper"
      :style="`background-image: url(${bootcamp.background_image_url})`"
    >
      <div class="bootcamp__pass">
        <Passes :passName="learningAreaName" :size="45" />
      </div>
      <div class="bootcamp__instructors-profile-imgs">
        <img
          v-for="instructor in limitedInstructors"
          :key="instructor.id"
          :src="getInstructorImg(instructor)"
          class="bootcamp__instructor-img"
          :alt="getInstructorName(instructor)"
        />
      </div>
      <div
        class="bootcamp__instructors-profile-imgs-plus"
        v-if="bootcamp.instructors.length > 2"
      >
        + {{ bootcamp.instructors.length - 2 }}
      </div>
    </div>
    <div class="bootcamp__info-wrapper">
      <div class="bootcamp__info">
        <h4 class="bootcamp__title">
          <router-link
            :to="{ name: 'bootcamp', params: { id: bootcampId } }"
            class="bootcamp__title-link"
            >{{ bootcamp.name }}</router-link
          >
        </h4>
        <p class="bootcamp__instructors">With {{ contentInstructors }}</p>
        <p
          class="bootcamp__description"
          v-html="renderMarkdown(bootcamp.description)"
        ></p>
      </div>
      <div class="bootcamp__details">
        <div class="bootcamp__detail-wrapper">
          <p class="bootcamp__detail bootcamp__date">
            <CalendarIcon class="bootcamp__icon" />
            {{
              formatDate({
                start: bootcamp.start_datetime,
                end: bootcamp.end_datetime,
                epoch,
              })
            }}
            <i
              class="bootcamp__timezone-icon material-icons info-icon"
              role="presentation"
              v-tooltip="{
                content: `Local time: ${localTimeZone}`,
                placement: 'top-center',
              }"
            >
              info_outline
            </i>
          </p>
        </div>
        <div class="bootcamp__actions">
          <router-link
            :to="{ name: 'bootcamp', params: { id: bootcampId } }"
            class="bootcamp__link btn btn--secondary"
            >{{ seeDetailsButton }}</router-link
          >
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import Passes from '@/components/properties/Passes.vue'
import CalendarIcon from '@/assets/icons/bootcamps/date_icon.svg'
import { localTimezone, bootcampCommons } from '@/helpers/mixins'

export default {
  name: 'BootcampCard',
  mixins: [localTimezone, bootcampCommons],
  components: {
    Passes,
    CalendarIcon: { ...CalendarIcon, name: 'CalendarIcon' },
  },
  props: {
    bootcamp: {
      type: Object,
      required: true,
    },
    formatDate: {
      type: Function,
      required: true,
    },
    renderMarkdown: {
      type: Function,
      required: true,
    },
    learnMore: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
    epoch: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
  },
  computed: {
    bootcampId() {
      return this.bootcamp.id || this.bootcamp.objectID
    },
    seeDetailsButton() {
      return this.learnMore ? 'Learn more' : 'See Details'
    },
  },
}
</script>
